import { countBy } from "lodash-es";

import { getLocaleText } from "shared/boot/i18n";

import { type UrlData } from "../shared/types";
import { UrlStatus as UrlApiStatus } from "../useAddExternalItemsWorkflow/useUrlVerificationNotificationsSubscription";

// status color classes + order in which totals per status are being displayed in UI
export const URL_STATUSES_UI_CONFIG = new Map([
  [UrlApiStatus.alreadyAdded, "text-ds-green-7"],
  [UrlApiStatus.canBeAdded, "text-ds-blue-7"],
  [UrlApiStatus.cannotBeAdded, "text-ds-orange-6"],
]);

export const URLS_MAX_COUNT = 40;

export interface UrlsTotalForStatus {
  class: string;
  status: UrlApiStatus;
  text: string;
  value: number;
}

function pluralitySuffix(status: UrlApiStatus, value: number): string {
  if (status !== UrlApiStatus.cannotBeAdded) return "";

  return value === 1 ? "_singular" : "_plural";
}

export function displayableTotalsByStatus(
  urlsData: UrlData[]
): UrlsTotalForStatus[] {
  const totalsByStatus = countBy(urlsData, (urlData) => urlData.status);

  return [...URL_STATUSES_UI_CONFIG.entries()]
    .map(([status, cssClass]) => ({
      class: cssClass,
      status,
      value: totalsByStatus[status] ?? 0,
    }))
    .filter(({ value }) => value > 0)
    .map((total) => ({
      ...total,
      text: getLocaleText(
        `external_items_bulk_add_modal.total.${total.status}${pluralitySuffix(total.status, total.value)}`,
        { urlsCount: total.value }
      ),
    }));
}
